class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.variants = this.variants || [];
    this.getProductJsonData();
  }

  connectedCallback() {
    this.initSlider();
    this.addEventListener("input", this.handleInputChange.bind(this));
  }

  async getCurrentVariant() {
    const response = await fetch(window.location.href);
    const data = await response.text();
    const html = new DOMParser().parseFromString(data, "text/html");
    this.renderUI(html);
  }

  handleInputChange(e) {
    if (e.target.closest(".variant-picker")) {
      this.handleVariantChange(e);
    }
  }

  handleVariantChange(e) {
    const { name, value } = e.target;
    const variant = this.currentVariant(value);
    this.updateURL({
      variant: variant.id,
    });
  }

  currentVariant(variantId) {
    return this.product?.variants?.find(
      (v) => v.id?.toString() === variantId?.toString()
    );
  }

  updateURL(paramsObj = {}) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    Object.entries(paramsObj).forEach(([key, value]) => {
      params.set(key, value);
    });

    window.history.replaceState({}, "", `${url.pathname}?${params}`);

    this.getCurrentVariant();
  }

  renderUI(html) {
    if (
      this.querySelector(".edpi-inner-form") &&
      html.querySelector(".edpi-inner-form")
    ) {
      this.querySelector(".edpi-inner-form").innerHTML =
        html.querySelector(".edpi-inner-form").innerHTML;
    }
    if (
      this.querySelector(".edpi-product-title") &&
      html.querySelector(".edpi-product-title")
    ) {
      this.querySelector(".edpi-product-title").innerHTML = html.querySelector(
        ".edpi-product-title"
      ).innerHTML;
    }
    if (
      this.querySelector(".variant-picker") &&
      html.querySelector(".variant-picker")
    ) {
      this.querySelector(".variant-picker").innerHTML =
        html.querySelector(".variant-picker").innerHTML;
    }
    if (
      this.querySelector(".edpi-info-stock-message") &&
      html.querySelector(".edpi-info-stock-message")
    ) {
      this.querySelector(".edpi-info-stock-message").innerHTML =
        html.querySelector(".edpi-info-stock-message").innerHTML;
    }
  }

  initSlider() {
    try {
      this.thumb = new Swiper(".edpi-thumb-swiper", {
        direction: "vertical",
        spaceBetween: 10,
        slidesPerView: "auto",
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        },
        mousewheel: true,
      });

      this.gallery = new Swiper(".edpi-galler-swiper", {
        slidesPerView: 1,
        spaceBetween: 6,
        thumbs: {
          swiper: this.thumb,
        },
        breakpoints: {
          200: {
            slidesPerView: 1.3,
          },
          768: {
            slidesPerView: 1,
          },
        },
      });
    } catch (err) {}
  }

  async getProductJsonData() {
    try {
      const scriptTag = this.querySelector(
        'script[type="application/product-json"]'
      );

      const dataObject = JSON.parse(scriptTag.textContent);
      console.log("dataObject", dataObject);

      this.product = dataObject;
      await this.getVariantDOM(dataObject);

      return dataObject;
    } catch (error) {
      return null;
    }
  }

  async getVariantDOM(data) {
    if (this.product) {
      this.product?.variants?.map(async (variant) => {
        const response = await fetch(
          this.dataset.url + "?variant=" + variant.id
        );
        const data = await response.text();
        const html = new DOMParser().parseFromString(data, "text/html");
        variant.parse_html = html;
        variant.url = this.dataset.url + "?variant=" + variant.id;
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  customElements.define("product-information", ProductInformation);
});
